export class FetcherError extends Error {
  status: number;

  data: unknown;

  method: string;

  url: string;

  headers: Record<string, string>;

  constructor(requestUrl: string, response: Response, data: unknown, method: string) {
    const sanitizedUrl = FetcherError.sanitizeRequestUrl(requestUrl);
    const logPrefix = `Fetcher error: ${method.toUpperCase()} ${sanitizedUrl}`;
    super(`${logPrefix}: ${response.statusText || 'Internal Error.'}`);

    this.status = response.status || 500;
    this.data = data;
    this.method = method;
    this.url = response.url;
    this.headers = Object.fromEntries(response.headers.entries());
  }

  /**
   * Returns a sanitized URL for the request for the purpose of logging.
   */
  private static sanitizeRequestUrl(requestUrl: string) {
    // fallback for relative urls.
    const fallbackUrl = 'http://fallback:1337';

    try {
      const url = new URL(requestUrl, fallbackUrl);
      const origin = url.origin === fallbackUrl ? '' : url.origin;
      return origin + url.pathname.replace(/\/$/, ''); // remove trailing slash
    } catch (_error) {
      return '';
    }
  }
}
